<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.user_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.user_account_name">
                      <el-input v-model="mData.tableRules.dataSearch.value.account" clearable></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.user_right_to_use">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.roles"
                        :placeholder="aLang.c_select"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.accountRolesSearch"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column
            prop="disabled"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.user_lock"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.disabled"
                @change="fn_changeDisable(scope.row.id, scope.row.disabled)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="account"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.user_account_name"
            width="280"
          ></el-table-column>
          <el-table-column
            prop="so_the"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tg_card_number"
            width="280"
          ></el-table-column>
          <el-table-column prop="name" :label="aLang.user_name"></el-table-column>
          <el-table-column
            prop="roles"
            :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterRoles"
            :label="aLang.user_right_to_use"
            width="180"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                :disabled="fn_checkUpdateInformationRole(scope.row)"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
              <el-button
                size="mini"
                @click="fn_handle('changePass',scope.$index, scope.row)"
                v-b-popover.hover.left="'Đổi mật khẩu'"
                :disabled="fn_checkChangePassRole(scope.row)"
              >
                <i class="icon-key icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('changeRole',scope.$index, scope.row)"
                v-b-popover.hover.left="'Đổi quyền người dùng'"
                :disabled="fn_checkEditRole(scope.row)"
              >
                <i class="icon-user icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import NguoiDungModel from "./NguoiDungModel";
import AccountApi from "../../../moduleApi/AccountApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import KhachDuLichApi from '@/moduleApi/KhachDuLichApi';
import HuongDanVienApi from '@/moduleApi/HuongDanVienApi';

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "NguoiDung", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(NguoiDungModel.tableRules),
        dataDefault: {
          trangThai: NguoiDungModel.trangThai,
          accountRoles: DataService.accountRoles,
          accountRolesSearch: DataService.accountRolesSearch,
          listKhachDuLich: [],
          listHuongDanVien: [],
          listProfile: [],
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: (this.mData.tableRules.filters ? this.mData.tableRules.filters + "&" : "")+"roles:nin:SafePlaceManager,Destination,ExportChecklistData"
      };
      console.log("dataFilter",dataFilter);
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        }).catch(()=>{});
      }
      let res = await AccountApi.list(dataFilter);
      let resFilter = [];
      resFilter = res.result.filter(x => !x.roles.includes("SafePlaceManager"));
      let resData = await this.fn_changeData(resFilter);

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let arrAccountId = MethodService.findListItemDifferent(resData, "id");
      let reqProfileApi = ProfileApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqKhachDuLichApi = KhachDuLichApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqHuongDanVienApi = HuongDanVienApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let resProfileApi = await reqProfileApi;
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;

      this.mData.dataDefault.listProfile = resProfileApi.result;
      this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;
      $.each(resData, (index, item) => {
        // let resultProfile = resProfileApi.result.find(element => {
        //   return element.id == item.id;
        // });
        let nguoiGuiKhachDL = this.mData.dataDefault.listKhachDuLich.find(
          element => {
            return element.id == item.id;
          }
        );
        let nguoiGuiHDV = this.mData.dataDefault.listHuongDanVien.find(
          element => {
            return element.id == item.id;
          }
        );
        let nguoiGui = this.mData.dataDefault.listProfile.find(
          element => {
            return element.id == item.id;
          }
        );
        if (nguoiGuiKhachDL) {
          item.name =
            nguoiGuiKhachDL.ho_ten && nguoiGuiKhachDL.ho_ten.ho_ten && nguoiGuiKhachDL.ho_ten.ho_ten.trim() != ""
              ? nguoiGuiKhachDL.ho_ten.ho_ten
              : "Chưa có thông tin";
          // item.account = nguoiGuiKhachDL.so_the ? nguoiGuiKhachDL.so_the : "Chưa có thông tin";
          item.so_the = nguoiGuiKhachDL.so_the ? nguoiGuiKhachDL.so_the : "Chưa có thông tin";
        }
        else if(nguoiGuiHDV){
          item.name =
          nguoiGuiHDV.ho_ten && nguoiGuiHDV.ho_ten.ho_ten
            ? nguoiGuiHDV.ho_ten.ho_ten
            : "";
        }
        else if(nguoiGui){
          item.name =
          nguoiGui.ho_ten && nguoiGui.ho_ten.ho_ten
            ? nguoiGui.ho_ten.ho_ten
            : "";
        }
      });
      return resData;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "changePass") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
          query: {
            viewMode: "changePass"
          }
        });
      }
      if (type == "changeRole") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
          query: {
            viewMode: "changeRole"
          }
        });
      }
    },

    async fn_changeDisable(id, trangThai) {
      if (trangThai) {
        await AccountApi.disable(id);
      } else {
        await AccountApi.undisable(id);
      }
      this.fn_initTable();
    },

    //delete
    async fn_delete(id) {
      await AccountApi.delete(id);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if(this.mData.tableRules.dataSearch.value.roles == "User" || this.mData.tableRules.dataSearch.value.roles == "UserG"){
            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            ) + "&account:regex:^\\d+$";
            console.log("this.mData.tableRules.filters",this.mData.tableRules.filters);
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.sort = "";
            this.fn_initTable();
          }else{
            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.sort = "";
            this.fn_initTable();
            console.log("this.mData.tableRules.filters",this.mData.tableRules.filters);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = [];
      let rolesWithoutUser = [];
      cellValue.forEach(item => {
        let res = this.mData.dataDefault.accountRoles.find(function(el) {
          return el.code == item;
        });
        if (res) {
          roles.push(res.text);
        }

        if(roles.length == 2 ){
          rolesWithoutUser = roles.filter(x => (x != 'Khách du lịch'));
        }else{
          rolesWithoutUser = roles;
        }
      });
      return rolesWithoutUser.join(" ,");
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_checkEditRole(user) {
      if (user.roles.includes("TourGuide")
          || user.roles.includes("TourAgent")
          || user.roles.includes("UserG")
          ) {
        return true;
      } else if (
        user.roles.length == 1 &&
        (user.roles.includes("User") || user.roles.includes("UserG"))
      ) {
        return true;
      } else {
        return false;
      }
    },
    fn_checkChangePassRole(user) {
      if(user.roles.includes("UserG")){
        return true;
      }
      else if (
        user.roles.length == 1 &&
        user.roles.includes("User")
      ) {
        return true;
      } else {
        return false;
      }
    },
     fn_checkUpdateInformationRole(user) {
      if(user.roles.includes("TourGuide") || user.roles.includes("UserG") || user.roles.includes("TourAgent")){
        return true;
      }
      else if (
        user.roles.length == 1 &&
        (user.roles.includes("User") || user.roles.includes("UserG"))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  //run after render view
  created() {
    // this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
